import React, { useCallback, useEffect, useState } from 'react';
import SlideItem from './SlideItem';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function CarousalMsg({ message }) {
  const [cur, setCur] = useState(0);
  const len = message.length;

  const leftHandle = () => {
    setCur(cur - 1 < 0 ? len - 1 : cur - 1);
  };

  const rightHandle = useCallback(() => {
    setCur(cur + 1 > len - 1 ? 0 : cur + 1);
  }, [cur, len]);

  useEffect(() => {
    const interval = setTimeout(() => {
      rightHandle();
    }, 500000000);
    return () => clearTimeout(interval);
  }, [rightHandle]);

  return (
    <div className="rcw-message-content carousal-container">
      {/* Left Button */}
      <button
        className="carousal-button left"
        onClick={leftHandle}
        aria-label="Previous Slide"
      >
        <FaChevronLeft/>
      </button>

      {/* Slides */}
      {message.map((slide, index) => (
        <div key={index} className={`carousal-slide ${cur === index ? 'active' : ''}`}>
          {cur === index && <SlideItem slide={slide} />}
        </div>
      ))}

      {/* Right Button */}
      <button
        className="carousal-button right"
        onClick={rightHandle}
        aria-label="Next Slide"
      >
        <FaChevronRight/>
      </button>
    </div>
  );
}
export default CarousalMsg;
